import Vue from './common/vue-common';
import HeaderMenu from "./components/header/HeaderMenu";
import cr$ from "../common/crquery";
import HeaderTopFeature from "./components/header/HeaderTopFeature";
import HeaderAdvantagesSlider from "./components/header/HeaderAdvantagesSlider";
import HeaderMobile from "./components/header/HeaderMobile";

cr$.ready(() => requestIdleCallback(() => {
    if (cr$.byId('header-desktop-nav').exists()) {
        new Vue(HeaderMenu)
    }
    if (cr$.byId('header-mobile-nav').exists()) {
        new Vue(HeaderMobile)
    }

    if (cr$.byId('header-top-feature').exists()) {
        new Vue(HeaderTopFeature)
    }

    if (cr$.byId('mobile-advantages-slider-vue').exists()) {
        new Vue({
            el: '#mobile-advantages-slider-vue',
            components: {HeaderAdvantagesSlider},
            template: `
                <div id="advantages-mobile" class="hidden-sm-up">
                <HeaderAdvantagesSlider/>
                </div>`
        })
    }
}));